import React from 'react';

export default function CardPlaceholder({ width }: { width: string | number }): React.ReactElement {
  return <div className={`df-list-module-placeholder df-list-module-placeholder--${width}`} />;
}
